module.exports = __webpack_public_path__ + "img/offline.62ffacc7.png";